function Log(value) {
	if (window.console) {
		window.console.log(value);
	}
}

function Error(value) {
	if (window.console) {
		window.console.error(value);
	}
}

function Warn(value) {
	if (window.console) {
		window.console.warn(value);
	}
}

function Info(value) {
	if (window.console) {
		window.console.info(value);
	}
}

export { Log, Error, Warn, Info };